import { render, staticRenderFns } from "./AdminPoliciesPTO.vue?vue&type=template&id=5249505d&scoped=true&"
import script from "./AdminPoliciesPTO.vue?vue&type=script&lang=ts&"
export * from "./AdminPoliciesPTO.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249505d",
  null
  
)

export default component.exports